import { OrganizationDetailFragment, WorkLocationFragment } from '@alice-financial/alice-sdk'
import { alpha } from '@alice-financial/pretext-ui'
import React from 'react'
import { LogoUploadButton } from '../LogoUploadButton'
import { useUpdateWorkLocationLogo } from './useUpdateWorkLocationLogo'

type WorkLocationLogoUploadButtonProps = {
  org: OrganizationDetailFragment
  location: WorkLocationFragment
}

export const WorkLocationLogoUploadButton: React.FC<WorkLocationLogoUploadButtonProps> = ({
  org,
  location,
}) => {
  const { mutateAsync: updateLocationLogo, isLoading } = useUpdateWorkLocationLogo(org)

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.item(0)
    if (file) {
      updateLocationLogo({
        logo: file,
        id: location.id,
      })
    }
  }

  return (
    <LogoUploadButton
      id={`work-location-${location.id}`}
      onChange={handleFileChange}
      disabled={isLoading}
      variant="outlined"
      color="primary"
      sx={(theme) => ({
        height: 'calc(100% - 3em)',
        width: 'calc(100% - 8px)',
        border: '3px dashed',
        textWrap: 'nowrap',
        borderColor: alpha(theme.palette.primary.main, 0.3),
      })}
    >
      {isLoading ? 'Uploading...' : 'Add logo'}
    </LogoUploadButton>
  )
}
